import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang } from "@/i18n";

const SEO = {
  "/": {
    title: { it: "Marketing Facile | Direzione Marketing per la tua Azienda", en: "Marketing Facile | Marketing Direction for your Company" },
    desc: {
      it: "Il tuo marketing non ha bisogno di altre attività: ha bisogno di una direzione. Strategia, branding e project management per aziende, fiere ed eventi.",
      en: "Your marketing doesn't need more activities: it needs one direction. Strategy, branding and project management for companies, fairs and events.",
    },
  },
  "/marketing-branding": {
    title: { it: "Marketing & Branding | Essential, Growth, Premium", en: "Marketing & Branding | Essential, Growth, Premium" },
    desc: {
      it: "Strategia, branding e coordinamento per aziende che vogliono crescere e differenziarsi. Tre livelli di direzione: Essential, Growth e Premium.",
      en: "Strategy, branding and coordination for companies that want to grow and stand out. Three levels of direction: Essential, Growth and Premium.",
    },
  },
  "/fiere-eventi-lanci": {
    title: { it: "Fiere, Eventi & Lanci | Direzione e Project Management", en: "Fairs, Events & Launches | Direction and Project Management" },
    desc: {
      it: "Direzione e coordinamento di fiere, eventi e lanci di prodotto: strategia, fornitori, materiali, logistica e follow-up. Tre livelli di progetto.",
      en: "Direction and coordination of fairs, events and product launches: strategy, suppliers, materials, logistics and follow-up. Three project levels.",
    },
  },
  "/servizi": {
    title: { it: "Servizi | Interventi Specifici di Marketing e Branding", en: "Services | Specific Marketing and Branding Interventions" },
    desc: {
      it: "Logo, brand identity, social, brochure, presentazioni e siti web: un catalogo di interventi specifici, gestiti con lo stesso metodo dei grandi progetti.",
      en: "Logo, brand identity, social media, brochures, presentations and websites: a catalogue of specific interventions, managed with the same method.",
    },
  },
  "/pacchetti/essential": {
    title: { it: "Pacchetto Essential — Direzione Marketing 2.400€", en: "Essential Package — Marketing Direction €2,400" },
    desc: {
      it: "Il pacchetto Essential: 4 settimane per mettere ordine nel marketing. Strategia, posizionamento, piano editoriale e roadmap finale. 2.400 € + IVA.",
      en: "The Essential package: 4 weeks to bring order to your marketing. Strategy, positioning, editorial plan and final roadmap. €2,400 + VAT.",
    },
  },
  "/pacchetti/growth": {
    title: { it: "Pacchetto Growth — Sviluppo Marketing 8.199€", en: "Growth Package — Marketing Development €8,199" },
    desc: {
      it: "Il pacchetto Growth: 3 mesi per costruire strategia, brand e comunicazione in modo integrato. 2.733 €/mese, 8.199 € + IVA complessivi.",
      en: "The Growth package: 3 months to build strategy, brand and communication in an integrated way. €2,733/month, €8,199 + VAT in total.",
    },
  },
  "/pacchetti/premium": {
    title: { it: "Pacchetto Premium — Direzione Continuativa 9.900€", en: "Premium Package — Ongoing Direction €9,900" },
    desc: {
      it: "Il pacchetto Premium: direzione marketing continuativa, coordinamento fornitori e responsabilità sul progetto. 3.300 €/mese per 3 mesi.",
      en: "The Premium package: ongoing marketing direction, supplier coordination and responsibility for the project. €3,300/month for 3 months.",
    },
  },
  "/pacchetti/fair-management": {
    title: { it: "Fair Management — Direzione Fiera 4.500€", en: "Fair Management — Fair Direction €4,500" },
    desc: {
      it: "Fair Management: direzione e coordinamento della partecipazione in fiera, dal brief al debrief. Fino a 4 settimane, 4.500 € + IVA.",
      en: "Fair Management: direction and coordination of your fair participation, from brief to debrief. Up to 4 weeks, €4,500 + VAT.",
    },
  },
  "/pacchetti/fair-business": {
    title: { it: "Fair Business — La Fiera Commerciale 8.500€", en: "Fair Business — The Commercial Fair €8,500" },
    desc: {
      it: "Fair Business: la fiera come strumento commerciale. Inviti, appuntamenti, lead management, follow-up e report KPI. Fino a 8 settimane, 8.500 € + IVA.",
      en: "Fair Business: the fair as a commercial tool. Invitations, appointments, lead management, follow-up and KPI report. Up to 8 weeks, €8,500 + VAT.",
    },
  },
  "/pacchetti/fair-product-launch": {
    title: { it: "Fair & Product Launch — Lancio in Fiera 12.900€", en: "Fair & Product Launch — Event Launch €12,900" },
    desc: {
      it: "Fair & Product Launch: lancia un prodotto o un brand attraverso fiera o evento. Strategia, concept, PR e coordinamento. Fino a 16 settimane, 12.900 € + IVA.",
      en: "Fair & Product Launch: launch a product or brand through a fair or event. Strategy, concept, PR and coordination. Up to 16 weeks, €12,900 + VAT.",
    },
  },
  "/case-study": {
    title: { it: "Case Study | Progetti Reali di Marketing e Fiere", en: "Case Studies | Real Marketing and Trade Fair Projects" },
    desc: {
      it: "Progetti reali gestiti dalla strategia alla realizzazione: Tykun/H1 al Monaco Yacht Show 2025 con la vittoria del Blue Wake, Sanya Balance, MED Defense.",
      en: "Real projects managed from strategy to delivery: Tykun/H1 at the Monaco Yacht Show 2025 with the Blue Wake win, Sanya Balance, MED Defense.",
    },
  },
  "/chi-sono": {
    title: { it: "Chi Sono | Cristina Angelini — Marketing Facile", en: "About Me | Cristina Angelini — Marketing Facile" },
    desc: {
      it: "Cristina Angelini: una figura tra strategia, marketing e project management. Dal problema alla realizzazione, con una sola direzione per ogni progetto.",
      en: "Cristina Angelini: a profile between strategy, marketing and project management. From the problem to delivery, with one direction for every project.",
    },
  },
  "/check-up": {
    title: { it: "Check-up Marketing | Analisi e Priorità in 90 Giorni", en: "Marketing Check-up | Analysis and Priorities in 90 Days" },
    desc: {
      it: "Prima di investire in altre attività, fai chiarezza: analisi di sito, comunicazione e posizionamento, sessione strategica e piano per 90 giorni. 490€ + IVA.",
      en: "Before investing in more activities, get clarity: website, communication and positioning analysis, strategy session and 90-day plan. €490 + VAT.",
    },
  },
  "/sito-essenziale": {
    title: { it: "Sito Essenziale 1.200€ | Sito Vetrina Professionale", en: "Essential Website €1,200 | Professional Showcase Site" },
    desc: {
      it: "Un sito vetrina professionale gestito come un progetto: analisi, struttura, contenuti, design responsive fino a 5 pagine e pubblicazione. 1.200€ + IVA.",
      en: "A professional showcase website managed as a project: analysis, structure, content, responsive design up to 5 pages and publication. €1,200 + VAT.",
    },
  },
  "/contatti": {
    title: { it: "Contatti | Raccontami il tuo Progetto | Marketing Facile", en: "Contact | Tell me about your Project | Marketing Facile" },
    desc: {
      it: "Raccontami il tuo progetto o il tuo problema di marketing: call conoscitiva gratuita di 20-30 minuti. Risposta personale entro 24-48 ore lavorative.",
      en: "Tell me about your project or your marketing problem: free 20-30 minute introductory call. Personal reply within 24-48 working hours.",
    },
  },
  "/privacy": {
    title: { it: "Privacy Policy | Marketing Facile — Cristina Angelini", en: "Privacy Policy | Marketing Facile — Cristina Angelini" },
    desc: {
      it: "Privacy Policy di Marketing Facile — Cristina Angelini: dati raccolti, finalità, conservazione e diritti dell'utente ai sensi del GDPR.",
      en: "Privacy Policy of Marketing Facile — Cristina Angelini: data collected, purposes, retention and user rights under the GDPR.",
    },
  },
  "/cookie": {
    title: { it: "Cookie Policy | Marketing Facile — Cristina Angelini", en: "Cookie Policy | Marketing Facile — Cristina Angelini" },
    desc: {
      it: "Cookie Policy di Marketing Facile — Cristina Angelini: solo cookie tecnici necessari al funzionamento del sito, nessun cookie di profilazione.",
      en: "Cookie Policy of Marketing Facile — Cristina Angelini: only technical cookies required for the site to work, no profiling cookies.",
    },
  },
};

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const SeoManager = () => {
  const { pathname } = useLocation();
  const { lang } = useLang();

  useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const entry = SEO[path];

    if (!entry) {
      setMeta("robots", "noindex, nofollow");
      return;
    }

    document.title = entry.title[lang] || entry.title.it;
    setMeta("description", entry.desc[lang] || entry.desc.it);
    setMeta("robots", "index, follow");

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", `${window.location.origin}${path}`);
  }, [pathname, lang]);

  return null;
};

export default SeoManager;
